module.exports = __webpack_public_path__ + "img/mobile.77ee5ac9.svg";